export default __webpack_public_path__ + "images/assets/ca2c4c96a021793b938f1ca0dcaaee77.svg";